@if(title){
  <div class="mb-4 flex items-center gap-3">
    <!-- Petit trait d'accent vertical gradient (décoratif, discret) -->
    <div class="h-7 w-1 rounded-full bg-gradient-to-b from-teal-500 to-emerald-500 shrink-0"></div>
    <h1 class="text-2xl lg:text-3xl font-extrabold text-slate-900 dark:text-white/90 tracking-tight leading-tight m-0" [innerHTML]="title"></h1>
  </div>
}
